import BottomSheet from '../../../../components/ui/BottomSheet';
import Select from '../../../../components/ui/Select';

/** Sort keys mirror the desktop SessionOptionsMenu — do not add new keys here. */
const SORT_BY_OPTIONS = [
  { value: 'location', label: 'Location' },
  { value: 'equipment_code', label: 'Equipment Code' },
];

/**
 * Sort assets bottom sheet — opened from the session summary sheet's "Sort assets"
 * row. Drives the shared `sessionSortBy` / `sessionSortOrder` hook state; the
 * grouped asset list re-sorts itself when that state changes, so this sheet only
 * sets state. Selecting a value closes the sheet.
 *
 * Props:
 *   open        — controlled open state
 *   onClose     — close handler
 *   sortBy      — current sort key ('location' | 'equipment_code')
 *   setSortBy   — setter for the sort key
 *   sortOrder   — current order ('asc' | 'desc')
 *   setSortOrder — setter for the order
 */
export default function SortAssetsSheet({
  open,
  onClose,
  sortBy = 'equipment_code',
  setSortBy,
  sortOrder = 'asc',
  setSortOrder,
}) {
  return (
    <BottomSheet open={open} onClose={onClose}>
      <div className="sort-assets-sheet">
        <div className="sort-assets-sheet__header">
          <h2 className="sort-assets-sheet__title">Sort assets</h2>
          <p className="sort-assets-sheet__subtitle">
            Choose how boards and circuits are ordered.
          </p>
        </div>

        <Select
          id="sort-assets-by"
          label="SORT BY"
          value={sortBy}
          onChange={(e) => { setSortBy?.(e.target.value); onClose(); }}
          className="sort-assets-sheet__select"
        >
          {SORT_BY_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </Select>

        <Select
          id="sort-assets-order"
          label="ORDER"
          value={sortOrder}
          onChange={(e) => { setSortOrder?.(e.target.value); onClose(); }}
          className="sort-assets-sheet__select"
        >
          <option value="asc">A–Z</option>
          <option value="desc">Z–A</option>
        </Select>
      </div>
    </BottomSheet>
  );
}
